<template>
  <div class="metafield-edit-liquid-template">
    <p style="color: red;">TODO!</p>
  </div>
</template>

<script>
export default {
  props: {
  }
}
</script>

<style lang="scss">
  .metafield-edit-liquid-template {

  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditLiquidTemplate.vue